import { Observable } from "rxjs";

import { environment } from 'src/environments/environment';

import { DevportalApiService } from "./devportal-api.service";
import { OpenApiV3 } from "src/app/models/openapi.model";
import { ApiDescription } from "src/app/models/model";


export class DevPortalApisServiceBase {

  private restApiUrl: string;

  constructor(
    private devportalApiService: DevportalApiService,
  ) {
    this.restApiUrl = `${environment.devportalApi.url}${environment.devportalApi.endpoints.apis}`;
  }

  protected get( name: string ) : Observable<OpenApiV3> {

    return this.devportalApiService.request("GET", `${this.restApiUrl}/${name}`);
  }

  protected getDevDoc( name: string ) : Observable<string> {

    return this.devportalApiService.request("GET", `${this.restApiUrl}/${name}/devdoc`);
  }

  protected getAll() : Observable<ApiDescription[]> {

    return this.devportalApiService.request("GET", `${this.restApiUrl}`);
  }
}
